import axios from "axios";
import { extractFileNameFromUrl } from "./extract-file-name-from-url";

// export async function imageUrlToFile(imageUrl: string): Promise<File> {
//   const fileName = extractFileNameFromUrl(imageUrl);
//   console.log("fileName", fileName);
//   console.log("imageUrl", imageUrl);
//   const response = await axios.get(imageUrl);
//   if (!response.ok) {
//     throw new Error(`Failed to fetch image: ${response.statusText}`);
//   }
//   const blob = await response.blob();
//   const file = new File([blob], fileName, {
//     type: response.headers.get("Content-Type") || "image/png",
//   });
//   return file;
// }

export async function imageUrlToFile(imageUrl: string): Promise<File> {
  const fileName = extractFileNameFromUrl(imageUrl);

  const url = imageUrl.startsWith("http")
    ? imageUrl + `?nocache=${new Date().getTime()}`
    : imageUrl;

  // Axios request with responseType set to 'blob' to get binary data
  const response = await axios.get(url, {
    responseType: "blob",
  });

  // Axios does not use `response.ok`, so checking if the status is in the success range
  if (response.status !== 200) {
    throw new Error(`Failed to fetch image: ${response.statusText}`);
  }

  // Create a file object from the blob data
  const file = new File([response.data], fileName, {
    type: response.headers["content-type"] || "image/png",
  });

  return file;
}

export async function imageUrlsToFiles(imageUrls: string[]): Promise<File[]> {
  try {
    const files = await Promise.all(
      imageUrls.map(async (imageUrl) => {
        const file = await imageUrlToFile(imageUrl);
        return file;
      })
    );
    return files;
  } catch (error) {
    console.error("Error reading image URLs:", error);
    throw error;
  }
}
